var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('v-row',{staticClass:"px-1 mt-2",attrs:{"no-gutters":""}},_vm._l((_vm.appointments),function(appointment){return _c('MercCard',{key:appointment.id,attrs:{"appointment":appointment}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }